import { Tooltip } from "@types/FormTypes";
import { __ } from "@wordpress/i18n";

/**
 * LABELS
 *
 * Centralized field labels for the Retirement Investment form.
 * These are used for dynamic field rendering and translations.
 */
export const CI_LABELS = {
  goalAmount: __("Montante", "df-simulators"),
  initialInvestment: __("Capital inicial", "df-simulators"),
  totalYears: __("Período total de investimento", "df-simulators"),
  frequencyAdditionalInvestment: __(
    "Frequência dos investimentos adicionais",
    "df-simulators",
  ),
  returnInterestRate: __(
    "Taxa média do retorno do investimento",
    "df-simulators",
  ),
  haveCompoundInterest: __(
    "Há capitalização de juros no investimento?",
    "df-simulators",
  ),
  capitalizationFrequency: __("Frequência de capitalização", "df-simulators"),
};

/**
 * TOOLTIPS
 *
 * Field-specific tooltips (translated) to assist the user with context.
 * Each tooltip includes a title, description and preferred placement.
 */
export const CI_TOOLTIPS: Record<string, Tooltip> = {
  goalAmount: __("Indique o montante que pretende atingir.", "df-simulators"),
  totalYears: __(
    "Indique o número de anos que tem para cumprir com o objetivo de poupança que estipulou.",
    "df-simulators",
  ),
  returnInterestRate: __(
    "Indique a taxa média anual de retorno do investimento (em %), considerando o histórico ou a expectativa de rendimento. Utilize um valor realista, antes de impostos e com base em dados fiáveis.",
    "df-simulators",
  ),
  haveCompoundInterest: __(
    "Indique se os juros gerados pelo investimento serão reinvestidos (capitalização) ou pagos separadamente.",
    "df-simulators",
  ),
};

export const CI_FREQUENCY_OPTIONS = {
  contribution_type: [
    { value: "monthly", label: __("Mensalmente", "df-simulators") },
    { value: "annual", label: __("Anualmente", "df-simulators") },
  ],
  capitalization_frequency: [
    { value: "monthly", label: __("Mensal", "df-simulators") },
    { value: "quarterly", label: __("Trimestral", "df-simulators") },
    { value: "semiannual", label: __("Semestral", "df-simulators") },
    { value: "annual", label: __("Anual", "df-simulators") },
  ],
};
